import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class RegistryLinkViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.REGISTRY_LINK_VIEW = '/api/registry-link-view';
    
        this.GET_BY_ID = '/{id}';
        this.GET_LIST_BY_PROJECT = '/list/project/{projectId}';

        this.GET_COUNT_BY_TARGET = '/count/target/{targetType}/id/{targetId}';
        this.GET_LIST_BY_REGISTRY = '/list/registry/{registryType}/id/{registryId}';
        this.GET_LIST_BY_REGISTRY_AND_TARGET = '/list/registry/{registryType}/id/{registryId}/target/{targetType}';
        this.GET_LIST_BY_TARGET = '/list/target/{targetType}/id/{targetId}';
        this.GET_LIST_BY_TARGET_AND_REGISTRY = '/list/target/{targetType}/id/{targetId}/registry/{registryType}';
        this.GET_PAGEABLE_LIST_BY_TARGET = "/pageable/list";
    }

    async getById(id) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_BY_ID;
            url = url
                .replace('{id}', id);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByProject(projectId) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_LIST_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByRegistryTypeAndRegistryId(registryType, registryId) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_LIST_BY_REGISTRY;
            url = url
                .replace('{registryType}', registryType)
                .replace('{registryId}', registryId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByRegistryTypeAndRegistryIdAndTargetType(registryType, registryId, targetType) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_LIST_BY_REGISTRY_AND_TARGET;
            url = url
                .replace('{registryType}', registryType)
                .replace('{registryId}', registryId)
                .replace('{targetType}', targetType);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByTargetTypeAndTargetId(targetType, targetId) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_LIST_BY_TARGET;
            url = url
                .replace('{targetType}', targetType)
                .replace('{targetId}', targetId);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getListByTargetTypeAndTargetIdAndRegistryType(targetType, targetId, registryType) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_LIST_BY_TARGET;
            url = url
                .replace('{targetType}', targetType)
                .replace('{targetId}', targetId)
                .replace('{registryType}', registryType);
            const invitations = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return invitations;
        } catch (err) {
            console.log(err);
        }
    }

    async getCountByTargetTypeAndTargetId(targetType, targetId) {
        try {
            let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_COUNT_BY_TARGET;
            url = url
                .replace('{targetType}', targetType)
                .replace('{targetId}', targetId);
            const count = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return count;
        } catch (err) {
            console.log(err);
        }
    }

    async getPageableList(bodyMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.REGISTRY_LINK_VIEW + this.GET_PAGEABLE_LIST_BY_TARGET;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(bodyMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default RegistryLinkViewService;
